module.exports = __webpack_public_path__ + "img/floor_f19_02.7aff0a7c.png";